// import React, { useState } from 'react';
// import { PiUserCircleDuotone } from 'react-icons/pi';
// import { RiLogoutCircleRLine } from 'react-icons/ri';
// import { BiSolidUserCircle } from 'react-icons/bi';
// import MenuItem from '@mui/material/MenuItem';
// import Menu from '@mui/material/Menu';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// const AdminProfileDropDown = () => {
//   const [anchorEl, setAnchorEl] = useState(null);
//   const navigate = useNavigate();

//   const profileDropdown = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const profileDropdownClose = () => {
//     setAnchorEl(null);
//   };

//   const handleLogout = () => {
//     profileDropdownClose();
//     localStorage.clear();
//     toast.success('Logged out successfully');
//     navigate('/login');
//   };
// const handleProfile = () => {
//     profileDropdownClose();
//     navigate('/profile');
//   };
//   return (
//     <div>
//       <PiUserCircleDuotone
//         onClick={profileDropdown}
//         size={40}
//         className="transition ease-in-out hover:text-[#2E3A8C] hover:duration-300 cursor-pointer"
//       />

//       <Menu
//         id="menu-appbar"
//         anchorEl={anchorEl}
//         anchorOrigin={{
//           vertical: 'top',
//           horizontal: 'right',
//         }}
//         keepMounted
//         transformOrigin={{
//           vertical: 'top',
//           horizontal: 'right',
//         }}
//         open={Boolean(anchorEl)}
//         onClose={profileDropdownClose}
//       >
//         <MenuItem onClick={handleProfile}>
//           <BiSolidUserCircle size={22} className="mr-2" />
//           Profile
//         </MenuItem>

//         <MenuItem onClick={handleLogout}>
//           <RiLogoutCircleRLine size={20} color="red" className="mr-2" />
//           Logout
//         </MenuItem>
//       </Menu>
//     </div>
//   );
// };

// export default AdminProfileDropDown;
import React, { useState, useEffect } from "react";
import { PiUserCircleDuotone } from "react-icons/pi";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { BiSolidUserCircle } from "react-icons/bi";
import { FiChevronDown } from "react-icons/fi";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const getProfileImageFromStorage = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return user?.profileImage || null;
  } catch {
    return null;
  }
};

const getUserFromStorage = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    return {};
  }
};

const AdminProfileDropDown = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [profileImage, setProfileImage] = useState(getProfileImageFromStorage);
  const [user, setUser] = useState(getUserFromStorage);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);

  useEffect(() => {
    const handleProfileUpdate = () => {
      setProfileImage(getProfileImageFromStorage());
      setUser(getUserFromStorage());
    };
    window.addEventListener("profileImageUpdated", handleProfileUpdate);
    return () =>
      window.removeEventListener("profileImageUpdated", handleProfileUpdate);
  }, []);

  const profileDropdown = (e) => setAnchorEl(e.currentTarget);
  const profileDropdownClose = () => setAnchorEl(null);

  const handleLogout = () => {
    profileDropdownClose();
    localStorage.clear();
    setProfileImage(null);
    toast.success("Logged out successfully");
    navigate("/login");
  };

  const handleProfile = () => {
    profileDropdownClose();
    navigate("/profile");
  };

  const roleBadgeColor = {
    admin: { bg: "#ede9fe", text: "#6d28d9" },
    agent: { bg: "#dbeafe", text: "#1d4ed8" },
    "sub-agent": { bg: "#fef9c3", text: "#a16207" },
  };
  const roleStyle = roleBadgeColor[user?.role] || {
    bg: "#f1f5f9",
    text: "#475569",
  };

  return (
    <>
      <style>{`
        /* ── Trigger button ── */
        .profile-trigger {
          display: flex;
          align-items: center;
          gap: 9px;
          padding: 5px 10px 5px 5px;
          border-radius: 12px;
          cursor: pointer;
          border: 1.5px solid transparent;
          transition: background 0.18s, border-color 0.18s, box-shadow 0.18s;
          background: transparent;
        }
        .profile-trigger:hover, .profile-trigger.open {
          background: #f0f3ff;
          border-color: #c7d0f5;
          box-shadow: 0 2px 10px rgba(46,58,140,0.08);
        }

        /* Avatar — fully rounded circle */
        .profile-avatar-wrap {
          position: relative;
          width: 45px;
          height: 45px;
          flex-shrink: 0;
        }
        .profile-avatar-img {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #e0e5f5;
          display: block;
          transition: border-color 0.18s;
        }
        .profile-trigger:hover .profile-avatar-img,
        .profile-trigger.open  .profile-avatar-img {
          border-color: #2E3A8C;
        }
        .profile-avatar-icon {
          color: #94a3b8;
          transition: color 0.18s;
          display: block;
        }
        .profile-trigger:hover .profile-avatar-icon,
        .profile-trigger.open  .profile-avatar-icon {
          color: #2E3A8C;
        }
        .online-dot {
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: 10px;
          height: 10px;
          background: #22c55e;
          border-radius: 50%;
          border: 2px solid #fff;
        }

        /* Name + role */
        .profile-info {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          line-height: 1.2;
          min-width: 0;
        }
        @media (max-width: 767px) { .profile-info { display: none; } }

        .profile-name {
          font-size: 0.82rem;
          font-weight: 700;
          color: #1e293b;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 110px;
          display: flex;
          align-items: center;
          gap: 3px;
        }
        .profile-role-badge {
          font-size: 0.6rem;
          font-weight: 600;
          padding: 1px 6px;
          border-radius: 20px;
          letter-spacing: 0.04em;
          text-transform: capitalize;
          white-space: nowrap;
        }

        .chevron-icon {
          color: #94a3b8;
          transition: transform 0.22s, color 0.18s;
          flex-shrink: 0;
        }
        .profile-trigger:hover .chevron-icon,
        .profile-trigger.open  .chevron-icon {
          color: #2E3A8C;
        }
        .chevron-icon.rotated { transform: rotate(180deg); }

        /* ── MUI Menu overrides ── */
        .vheeco-menu .MuiPaper-root {
          border-radius: 14px !important;
          border: 1.5px solid #e4e7f8 !important;
          box-shadow: 0 8px 30px rgba(46,58,140,0.13) !important;
          margin-top: 8px !important;
          min-width: 220px !important;
          overflow: visible !important;
        }
        .vheeco-menu .MuiList-root {
          padding: 6px !important;
        }

        /* Menu header card */
        .menu-header {
          padding: 12px 14px 10px;
          border-bottom: 1px solid #f1f5f9;
          margin-bottom: 4px;
        }
        .menu-header-inner {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        /* Avatar in menu header — also rounded circle */
        .menu-avatar {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #e0e5f5;
          flex-shrink: 0;
        }
        .menu-avatar-icon {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          background: #f0f3ff;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #2E3A8C;
          flex-shrink: 0;
        }
        .menu-email {
          font-size: 0.7rem;
          color: #94a3b8;
          margin-top: 1px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 150px;
        }
        .menu-entity {
          font-size: 0.68rem;
          color: #2E3A8C;
          font-weight: 600;
          margin-top: 2px;
          font-family: 'Courier New', monospace;
          letter-spacing: 0.04em;
        }

        /* Menu items */
        .vheeco-menu-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 12px !important;
          border-radius: 9px !important;
          font-size: 0.83rem !important;
          font-weight: 500 !important;
          color: #334155 !important;
          transition: background 0.15s, color 0.15s !important;
          margin: 1px 0 !important;
        }
        .vheeco-menu-item:hover {
          background: #f0f3ff !important;
          color: #2E3A8C !important;
        }
        .vheeco-menu-item.danger:hover {
          background: #fff1f2 !important;
          color: #dc2626 !important;
        }
        .item-icon {
          width: 30px;
          height: 30px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .item-icon.blue { background: #eef0f8; color: #2E3A8C; }
        .item-icon.red  { background: #fff1f2; color: #dc2626; }

        .menu-separator {
          height: 1px;
          background: #f1f5f9;
          margin: 4px 0;
        }

        /* Status chip */
        .status-chip {
          display: flex;
          align-items: center;
          gap: 5px;
          padding: 3px 8px 3px 5px;
          background: #f0fdf4;
          border: 1px solid #bbf7d0;
          border-radius: 20px;
          font-size: 0.62rem;
          font-weight: 600;
          color: #15803d;
          margin-top: 5px;
          width: fit-content;
        }
        .status-chip-dot {
          width: 6px;
          height: 6px;
          background: #22c55e;
          border-radius: 50%;
        }
      `}</style>

      {/* Trigger */}
      <div
        className={`profile-trigger ${open ? "open" : ""}`}
        onClick={profileDropdown}
        aria-label="User menu"
      >
        <div className="profile-avatar-wrap">
          {profileImage ? (
            <img
              src={profileImage}
              alt="profile"
              className="profile-avatar-img"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://via.placeholder.com/150";
              }}
            />
          ) : (
            <PiUserCircleDuotone size={36} className="profile-avatar-icon" />
          )}
          <span className="online-dot" />
        </div>

        {/* <FiChevronDown
          size={15}
          className={`chevron-icon ${open ? "rotated" : ""}`}
        /> */}
      </div>

      {/* Dropdown Menu */}
      <Menu
        className="vheeco-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={profileDropdownClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            borderRadius: "14px",
            border: "1.5px solid #e4e7f8",
            boxShadow: "0 8px 30px rgba(46,58,140,0.13)",
            mt: 1,
            minWidth: 220,
            overflow: "visible",
          },
        }}
      >
        {/* Header */}
        <div className="menu-header">
          <div className="menu-header-inner">
            {profileImage ? (
              <img
                src={profileImage}
                alt="profile"
                className="menu-avatar"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://via.placeholder.com/150";
                }}
              />
            ) : (
              <div className="menu-avatar-icon">
                <PiUserCircleDuotone size={24} />
              </div>
            )}
            <div style={{ minWidth: 0 }}>
              <div className="menu-email">{user?.email || ""}</div>
              {user?.entityId && (
                <div className="menu-entity">#{user.entityId}</div>
              )}
            </div>
          </div>
          <div className="status-chip">
            <span className="status-chip-dot" />
            Active
          </div>
        </div>

        {/* Profile */}
        <MenuItem
          className="vheeco-menu-item"
          onClick={handleProfile}
          disableRipple
        >
          <span className="item-icon blue">
            <BiSolidUserCircle size={17} />
          </span>
          My Profile
        </MenuItem>

        <div className="menu-separator" />

        {/* Logout */}
        <MenuItem
          className="vheeco-menu-item danger"
          onClick={handleLogout}
          disableRipple
        >
          <span className="item-icon red">
            <RiLogoutCircleRLine size={16} />
          </span>
          LOG Out
        </MenuItem>
      </Menu>
    </>
  );
};

export default AdminProfileDropDown;
